import React, { useState } from 'react';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';
import { StepFooterNav } from '../../components/StepFooterNav';
import { Stack } from '@mui/material';
import { FormSectionHeader } from 'components/shared/FormSectionHeader';
import { QuillInputField } from 'components/form';
import { DealBuilderFormValues } from 'modules/dealBuilder';
import { useFormContext } from 'react-hook-form';
import { ReviewAndSendFields } from './ReviewAndSendFields';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';
import { useProposal } from 'modules/proposals/hooks/useProposal';
import { generateQuoteProposalPageURL } from 'utils/generateQuoteProposalPageURL';
import { Account } from 'types';
import { useSelector } from 'react-redux';
import { useDealBuilderContext } from 'modules/dealBuilder/context/DealBuilderContext';

export const ReviewAndSendStep = () => {
  const account = useSelector<any, Account>(state => state.account);

  const { activeEntity, selectedEquipmentItem, vo } = useDealBuilderContext();
  const { isQuoteProposalPreviewCreating, handleCreatePreviewQuoteProposal } = useProposal();
  const { control, setValue, getValues } = useFormContext<DealBuilderFormValues>();

  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [linkToProposalPage, setLinkToProposalPage] = useState<string | null>(null);

  const handleTogglePreview = async (sectionValue: string, isOpen: boolean) => {
    setIsPreviewOpen(isOpen);

    if (isOpen) {
      const proposalId = await handleCreatePreviewQuoteProposal({
        voId: vo!.vendorOpportunityId,
        proposalSettings: {
          meta: {
            equipmentId: selectedEquipmentItem?.equipment?.id ?? null,
            originalProposalId: activeEntity?.proposal?.proposalId ?? null,
          },
        },
      });

      if (!proposalId) return;

      const linkToProposalPage = generateQuoteProposalPageURL(proposalId, account.dynamicsAccountId!);
      setLinkToProposalPage(linkToProposalPage);
    } else {
      setLinkToProposalPage(null);
    }
  };

  return (
    <CardContainer
      title="Review & Send"
      subTitle="Please review the quote details and add any notes for the customer before sending."
    >
      <Stack gap={2}>
        <Stack gap={1}>
          <FormSectionHeader name="Notes To Buyer" value="notesToBuyer" />
          <QuillInputField
            control={control}
            setValue={setValue}
            getValues={getValues}
            name="reviewSend.notesToBuyer"
            placeholder="Add notes that will be visible to the buyer..."
          />
        </Stack>

        <Stack gap={1}>
          <FormSectionHeader
            name="Quote Review"
            value="quoteReview"
            isSectionOpen={isPreviewOpen}
            handleUpdateOpenStatus={handleTogglePreview}
          />
          <RenderWithCondition condition={isPreviewOpen}>
            {isQuoteProposalPreviewCreating && <Stack>Loading preview...</Stack>}
            {linkToProposalPage && (
              <iframe
                id="dealBuilderPreviewIframe"
                style={{ height: '80vh', minHeight: 600, border: 'none', display: 'block' }}
                /* sandbox={'allow-scripts allow-top-navigation allow-same-origin'} */
                src={linkToProposalPage}
              />
            )}
          </RenderWithCondition>
        </Stack>

        <ReviewAndSendFields />
      </Stack>
      <StepFooterNav />
    </CardContainer>
  );
};
